import * as React from 'react';
import { PaddingOptions } from '../../../sharedComponents/core/Cards/Card';
import { createUseStyles, useTheme } from 'react-jss';
import classNames from 'classnames';
import { Theme } from 'helpers/theme';
import Graph from './Graph';
import { useRouter } from 'found';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    background: 'white'
  },
  root: {
    display: 'flex',
    flexDirection: 'column'
  },
  heading: {
    fontSize: theme.fontSizes.small,
    color: theme.colors.primaryBlack,
    padding: 14
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  button: {
    alignSelf: 'center',
    marginTop: '50px'
  },
  marginBottom: {
    margin: '0 0 15px 0'
  },
  card: {
    padding: '22px 24px',
    fontSize: 14
  },
  cards: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr'
  },
  topTitle: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  catTitle: {
    fontWeight: 800
  },
  catLabel: {
    color: '#6A728F',
    fontSize: 13
  },
  graphContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    marginTop: 13,
    width: '100%'
  },
  graph: {
    display: 'flex',
    alignSelf: 'center',
    justifyContent: 'center',
    margin: '10px 0 10px 0'
  },
  certPercentage: {
    fontSize: 14,
    fontWeight: 800,
    textAlign: 'center'
  },
  percentageLabel: {
    color: '#6A728F',
    fontSize: 12,
    textAlign: 'center'
  },
  infoText: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  divider: {
    width: '100%',
    height: 1,
    background: '#F6F6F7'
  }
}));

type Props = {
  title: string;
  normal: {
    label: string;
    labelValue: string;
  };
  outer: {
    value: number; // The percentage of the outer circle
    labelValue: string; // The value to show on the right label
    label: string; // The label to show on the right
    onClick: () => void;
  };
  inner: {
    value: number; // The percentage of the outer circle
    labelValue: string; // The value to show on the right label
    label: string; // The label to show on the right
    onClick: () => void;
  };
  subLabel: string;
  onClick?: Function;
  padding?: PaddingOptions;
  className?: string;
  rightBorder?: boolean;
  bottomBorder?: boolean;
};

export default function StatusSection({
  title,
  subLabel,
  normal,
  outer,
  inner,
  rightBorder = true,
  bottomBorder = true
}: Props) {
  const theme = useTheme();
  const classes = useStyles({ theme });

  const { router } = useRouter();

  const [innerHover, setInnerHover] = React.useState(false);
  const [outerHover, setOuterHover] = React.useState(false);

  return (
    <div
      className={classes.card}
      style={{
        borderBottom: bottomBorder ? '1px solid #F6F6F7' : 'none',
        borderRight: rightBorder ? '1px solid #F6F6F7' : 'none'
      }}
    >
      <div className={classes.topTitle}>
        <div className={classes.catTitle}>{title}</div>
        <div className={classes.catLabel}>{subLabel}</div>
      </div>
      <div className={classes.graphContainer}>
        <Graph
          className={classNames(classes.graph)}
          outerValue={outer.value}
          innerValue={inner.value}
          onHoverInner={(val) => setInnerHover(val)}
          onHoverOuter={(val) => setOuterHover(val)}
          onClickInner={inner.onClick}
          onClickOuter={outer.onClick}
        />
        {!innerHover && !outerHover && (
          <div className={classes.infoText}>
            <div className={classes.certPercentage}>{normal.labelValue}</div>
            <div className={classes.percentageLabel}>{normal.label}</div>
          </div>
        )}
        {innerHover && outerHover && (
          <div className={classes.infoText}>
            <div className={classes.certPercentage}>{inner.labelValue}</div>
            <div className={classes.percentageLabel}>{inner.label}</div>
          </div>
        )}
        {outerHover && !innerHover && (
          <div className={classes.infoText}>
            <div className={classes.certPercentage}>{outer.labelValue}</div>
            <div className={classes.percentageLabel}>{outer.label}</div>
          </div>
        )}
      </div>
    </div>
  );
}
